import { render } from "./Totals.vue?vue&type=template&id=1fe77de5"
import script from "./Totals.vue?vue&type=script&lang=js"
export * from "./Totals.vue?vue&type=script&lang=js"

import "./Totals.vue?vue&type=style&index=0&id=1fe77de5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__